//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {throttle} from 'throttle-debounce';
import assetUrl from "../js/components/assetUrl";

export default {
  data() {
    return {
      links: [
          {sectionId: '#finance', text: 'menu.finance'},
          {sectionId: '#events', text: 'menu.events'},
          {sectionId: '#awards', text: 'menu.awards'},
          {sectionId: '#mediapresence', text: 'menu.mediapresence'},
          {sectionId: '#map', text: 'menu.map'},
          {sectionId: '#prod-services', text: 'menu.prod-services'},
          {sectionId: '#vectors', text: 'menu.vectors'},
          {sectionId: '#clients', text: 'menu.clients'},
          {sectionId: '#topManagement', text: 'menu.topManagement'},
          {sectionId: '#normality', text: 'menu.normality'},
          {sectionId: '#culture', text: 'menu.culture'},
          {sectionId: '#career', text: 'menu.career'},
          {sectionId: '#internal-cifra', text: 'menu.internal-cifra'},
          {sectionId: '#vz', text: 'menu.vz'},
          {sectionId: '#corp', text: 'menu.corp'},
          {sectionId: '#quality', text: 'menu.quality'},
          {sectionId: '#strategy', text: 'menu.strategy'},
      ],
      activeLink: null,
      offsetHeader: 64,
      numSlidesInView: 7 - 1,
      transformWrapperHeight: '100%',
      transformContainer3D: 'translate3d(0, 0, 0)',
      menuColor: 'black',
      hideMenu: false,
    }
  },
  computed: {
    linkClass() {
      return (navLink) => {
        let rows = [];
        if (navLink.isActive) {
          rows.push('menu__item_active');
        }

        if (this.activeLink) {
          const diff = this.activeLink.id - navLink.id;

          if (diff === 1) {
            rows.push('menu__item_last');
          } else if (diff === -1) {
            rows.push('menu__item_next');
          }
        }
        return rows.join(' ');
      }
    },
    linkStyle() {
      return (navLink) => {
        if (navLink.color) {
          return {
            color: navLink.color
          }
        }
      }
    },
    isMenuOpened() {
      return this.$store.state.isMenuOpened;
    }
  },
  created() {
    this.links.forEach((el, key) => {
      this.$set(el, 'id', key);
      this.$set(el, 'isActive', false);
      this.$set(el, 'section', null);
      this.$set(el, 'color', null);
    });
  },
  mounted() {
    const header = document.querySelector('.header');
    if (header) {
      this.offsetHeader = header.offsetHeight + 1;
    }

    window.addEventListener('resize', throttle(400, () => {
      if (header) {
        this.offsetHeader = header.offsetHeight + 1;
      }
    }));

    this.calculateMenuInversion();
    window.addEventListener('scroll', throttle(400, (e) => {
      if (this.$store.state.isProgramScrollingNow === 0) {
        let calculatedItem = this.calculateNavItem(window.scrollY);
        if (!calculatedItem && this.activeLink) {
          this.activateNavItem(null);
        }
        if (calculatedItem && ((this.activeLink && calculatedItem.id !== this.activeLink.id) || !this.activeLink)) {
          this.activateNavItem(calculatedItem);
        }

        this.calculateMenuInversion();
      }
    }));

    this.$nextTick(() => {
      this.calculateTransformWrapperStyle();
    });
  },
  methods: {
    onGoNext(step) {
      let activeIndex = -1;
      if (this.activeLink !== null) {
        activeIndex = this.activeLink.id;
      }
      const nextId = step + activeIndex;
      const nextEl = this.links.find((item) => {
        return item.id === nextId;
      });
      if (nextEl) {
        this.onClick(nextEl);
      }
    },
    onClick(navItem, event) {
      if (event) {
        event.preventDefault();
      }
      this.activateNavItem(navItem);
      this.scrollToNavSection(document.querySelector(navItem.sectionId), 600);
      this.$store.dispatch('menuOpen', false);
    },
    calculateNavItem(windowOffset) {
      let activeNavItem = null;
      for (let i = 0, length = this.links.length; i < length; i++) {
        const navItem = this.links[i];
        if (!navItem.section) {
          navItem.section = document.querySelector(navItem.sectionId);
        }
        const section = navItem.section;
        if (section && this.getOffsetTop(section) - this.offsetHeader <= windowOffset) {
          activeNavItem = navItem;
        }
      }

      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 2) {
        activeNavItem = this.links[this.links.length - 1];
      }

      return activeNavItem;
    },
    getOffsetTop(element) {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    },
    activateNavItem(navItem) {
      if (this.activeLink) {
        this.activeLink.isActive = false;
      }

      if (navItem !== null) {
        navItem.isActive = true;
      }
      this.activeLink = navItem;

      this.$nextTick(() => {
        this.calculateTransformWrapperStyle();
      });
    },
    scrollToNavSection(element, duration) {
      this.$store.dispatch("scrollToElement", {
        element,
        duration
      });
    },
    calculateMenuInversion() {
      const sectionElements = document.querySelectorAll('[data-menu-section-inversion-id]');
      let sections = [];
      sectionElements.forEach((sectionElement) => {
        const offsetTop = this.getOffsetTop(sectionElement);
        sections.push({
          color: sectionElement.getAttribute('data-menu-section-inversion-id'),
          offsetTop: offsetTop,
          offsetBottom: offsetTop + sectionElement.offsetHeight,
        });
      });
      sections.sort((elementA, elementB) => {
        return elementA.offsetTop > elementB.offsetTop ? 1 : -1;
      });

      const navLinkElement = this.$refs[`menuMainContainer`];
      const navLinkOffsetTop = this.getOffsetTop(navLinkElement),
          navLinkHeight = navLinkElement.offsetHeight;
      const currentSection = sections.find((section) => {
        return (navLinkOffsetTop + navLinkHeight / 2) >= section.offsetTop && navLinkOffsetTop + (navLinkHeight / 2) < section.offsetBottom;
      });


      if (currentSection) {
        this.menuColor = currentSection.color;
      } else {
        this.menuColor = 'black';
      }

      const isInPresentation = Array.prototype.slice.call(document.querySelectorAll('.presentation__section')).find((item) => {
        const containerOffsetTop = this.getOffsetTop(item);
        return (
            (navLinkOffsetTop >= containerOffsetTop && containerOffsetTop + item.offsetHeight >= navLinkOffsetTop ) ||
            (navLinkOffsetTop + navLinkHeight + 100 >= containerOffsetTop && navLinkOffsetTop + navLinkHeight + 100 <= containerOffsetTop + item.offsetHeight)
        );
      });

      this.hideMenu = !!isInPresentation;
    },
    calculateTransformWrapperStyle() {
      if (this.$mq === 'mobile') {
        this.transformWrapperHeight = `auto`;
        this.transformContainer3D = `translate3d(0, 0, 0)`;
        return;
      }
      const activeLinkId = this.activeLink ? this.activeLink.id : 0,
          maxLinkId = this.links.length - 1;

      let calculatedResult = {
        maxLinkId: maxLinkId,
        minLinkId: 0,
        offsetNumber: 0,
        bottomOffsetNumber: 0,
      }

      if (activeLinkId !== 0) {
        calculatedResult.offsetNumber = 1;
      }

      if (activeLinkId + this.numSlidesInView - calculatedResult.offsetNumber > maxLinkId) {
        calculatedResult.maxLinkId = maxLinkId;
        calculatedResult.minLinkId = maxLinkId - this.numSlidesInView;
      } else {
        calculatedResult.maxLinkId = activeLinkId + this.numSlidesInView - calculatedResult.offsetNumber;
        calculatedResult.minLinkId = calculatedResult.maxLinkId - this.numSlidesInView;
      }

      let sumHeight = 0;
      for (let i = calculatedResult.minLinkId; i <= calculatedResult.maxLinkId; i++) {
        const currentRef = this.$refs[`menuLink${i}`][0];
        sumHeight += currentRef.offsetHeight;
      }

      let transformHeight = 0;
      for (let i = 0; i < calculatedResult.minLinkId; i++) {
        const currentRef = this.$refs[`menuLink${i}`][0];
        transformHeight += currentRef.offsetHeight;
      }

      this.transformWrapperHeight = `${sumHeight}px`;
      this.transformContainer3D = `translate3d(0, -${transformHeight}px, 0)`;
    },
  }
};
